import { useContext, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { Title, ViewportContext } from "@monorepo/components";
import { setMobilePopUp } from "@monorepo/slices/misc";
import theme from "@monorepo/styles/theme";
import { Box, styled, SxProps } from "@mui/system";

interface IProps {
  title: string;
  onClose: () => void;
  overlaySx?: SxProps;
  contentSx?: SxProps;
}
const StyledCloseIcon = styled(IoMdClose)(() => ({
  position: "absolute",
  left: theme.spacing(3),
  top: theme.spacing(3),
}));

export const MobilePopUp: React.FC<IProps> = ({ title, children, onClose, overlaySx, contentSx }) => {
  const { isMobile } = useContext(ViewportContext);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setMobilePopUp(true));

    return () => {
      dispatch(setMobilePopUp(false));
    };
    // on load only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      id="mobile-pop-up"
      sx={{
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: "2",
        height: "100vh",
        minWidth: "100vw",
        background: theme.palette.background.default,
        overflow: "hidden auto",
        pb: theme.spacing(2),
        ...overlaySx,
      }}
    >
      {isMobile && <StyledCloseIcon fontSize="2rem" onClick={onClose} />}
      <Box sx={{ marginTop: theme.spacing(3) }}>
        <Title>{title}</Title>
      </Box>
      <Box margin="auto" sx={{ ...contentSx }}>
        {children}
      </Box>
    </Box>
  );
};
